export enum MakeLogoType {
  CARS = 'cars',
  BIKES = 'bikes'
}
